import { Layout } from '@/views/gap-backtest';

export default {
    path: '/gap-backtest',
    component: Layout,
    children: [
        { path: 'shortlist', component: () => import('@/views/gap-backtest/GapBacktestShortlist.vue') },
        { path: 'live', component: () => import('@/views/gap-backtest/LivePaperTrading.vue') },
        { path: 'settings', component: () => import('@/views/gap-backtest/PaperTradingSettings.vue') },
        { path: 'day-review', component: () => import('@/views/gap-backtest/DayReview.vue') },
        { path: 'watchlist', component: () => import('@/views/gap-backtest/Watchlist.vue') },
        { path: 'data-quality', component: () => import('@/views/gap-backtest/DataQuality.vue') },
        { path: 'param-optimizer', component: () => import('@/views/gap-backtest/ParamOptimizer.vue') },
        { path: 'universe', component: () => import('@/views/gap-backtest/StockUniverse.vue') },
        { path: 'strategy-config', component: () => import('@/views/gap-backtest/StrategyConfig.vue') },
        { path: 'corporate-events', component: () => import('@/views/gap-backtest/CorporateEvents.vue') },
    ]
};
